import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Dialog from '@visa/vds/dialog';
import DialogCardBody from '@visa/vds/dialog-card-body';
import DialogCardFooter from '@visa/vds/dialog-card-footer';
import DialogCardHead from '@visa/vds/dialog-card-head';
import DialogCardHeadIcon from '@visa/vds/dialog-card-head-icon';
import DialogCardHeadTitle from '@visa/vds/dialog-card-head-title';
import Grid from '@visa/vds/grid';
import Icon from '@visa/vds/icon';
import Typography from '@visa/vds/typography';
import MCSSpace from 'components/MCSSpace';
import React from 'react';

const VSTTSubscriptionExistingWarningDialog = (props) => {
    return (
        <>
            <Dialog
                aria-describedby="VSTT subscription exist warning"
                onExit={() => { }}
                open={props.openSubscriptionWarningDialog}
                type="error"
                titleId="dialog-subscription-error"
            >
                <DialogCardHead>
                    <DialogCardHeadIcon>
                        <Icon name="error" resolution="low" />
                    </DialogCardHeadIcon>
                    <DialogCardHeadTitle id="dialog-title-manage-file">Error</DialogCardHeadTitle>
                </DialogCardHead>

                <DialogCardBody id="dialog-description-manage-file-field">
                    <Grid>
                        <Typography tag="h4">The following Subscriptions have already been purchased: </Typography>
                        <Typography>
                            <ul>
                                {props.checkExistingVsttSubscriptions && props.checkExistingVsttSubscriptions != null && props.checkExistingVsttSubscriptions.map((item, key) => (
                                    <li>{item.productName}</li>
                                ))}
                            </ul>
                        </Typography>
                    </Grid>
                    <MCSSpace />
                </DialogCardBody>
                <DialogCardFooter>
                    <ButtonGroup direction="right">
                        <ButtonText
                            colorScheme="primary"
                            onClick={() => {
                                props.setOpenSubscriptionWarningDialog(null);
                            }}
                        >
                            OK
                        </ButtonText>
                    </ButtonGroup>
                </DialogCardFooter>
            </Dialog>
        </>
    )
}

export default VSTTSubscriptionExistingWarningDialog